import React, { useRef, useState, useEffect } from "react";
import "./styles/FeedbackCarousel.css";

const FeedbackCarousel = ({ feedbacks }) => {
  const carouselRef = useRef(null);
  const [isDragging, setIsDragging] = useState(false);
  const [startX, setStartX] = useState(0);
  const [scrollLeft, setScrollLeft] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const carousel = carouselRef.current;
    let animationFrameId;

    const scroll = () => {
      if (!isHovered && carousel) {
        carousel.scrollLeft += 1;
        if (carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth) {
          carousel.scrollLeft = 0;
        }
      }
      animationFrameId = requestAnimationFrame(scroll);
    };

    const startAutoScroll = () => {
      animationFrameId = requestAnimationFrame(scroll);
    };

    const stopAutoScroll = () => {
      cancelAnimationFrame(animationFrameId);
    };

    if (!isHovered && carousel) {
      startAutoScroll();
    }

    return () => {
      stopAutoScroll();
    };
  }, [isHovered]);

  const handleMouseDown = (e) => {
    setIsDragging(true);
    setStartX(e.pageX - carouselRef.current.offsetLeft);
    setScrollLeft(carouselRef.current.scrollLeft);
    carouselRef.current.style.cursor = 'grabbing';
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;
    e.preventDefault();
    const x = e.pageX - carouselRef.current.offsetLeft;
    const walk = (startX - x) * 2; // Multiply by 2 for smoother scrolling
    carouselRef.current.scrollLeft = scrollLeft + walk;
  };

  const handleMouseUp = () => {
    setIsDragging(false);
    carouselRef.current.style.cursor = 'grab';
  };

  const handleMouseLeave = () => {
    setIsDragging(false);
    setIsHovered(false);
    carouselRef.current.style.cursor = 'grab';
  };

  const handleMouseEnter = () => {
    setIsHovered(true);
    carouselRef.current.style.cursor = 'grab';
  };

  const getRatingIcon = (rating) => {
    if (rating < 1) {
      return '😞';
    } else if (rating < 2) {
      return '😕';
    } else if (rating < 3) {
      return '😐';
    } else if (rating < 4) {
      return '🙂';
    } else if (rating < 5) {
      return '😀';
    } else {
      return '⭐';
    }
  };

  return (
    <div
      className={`reviews-carousel-container ${isDragging ? 'dragging' : ''}`}
      ref={carouselRef}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      onMouseEnter={handleMouseEnter}
    >
      {feedbacks.map((feedback, index) => (
        <div className="reviews-carousel-card glass-box" key={index}>
          <div className="reviews-carousel-icon">{getRatingIcon(feedback.rating)}</div>
          <p className="reviews-carousel-text">{feedback.text}</p>
          <div className="reviews-carousel-rating">
            {feedback.rating}
          </div>
        </div>
      ))}
    </div>
  );
};

export default FeedbackCarousel;